import GraphQL from './GraphQL'

class LocationClass {
    constructor() {
        
    }

    getList(cb, IDS = [], fields={ ID : null, COUNTRY : null, COUNTRY_CODE : null, REGION : null, CITY : null, ZIP : null, LATITUDE : null, LONGITUDE : null, TIMEZONE : null, LANG : null }) {
        GraphQL.query('location_get_list', {
            'IDS : [Int]!' : IDS
        }, fields, cb)
    }

    search(cb, PHRASE = null, fields={ ID : null, COUNTRY : null, COUNTRY_CODE : null, REGION : null, CITY : null, ZIP : null, LATITUDE : null, LONGITUDE : null, TIMEZONE : null, LANG : null }) {
        GraphQL.query('location_search', {
            'PHRASE : String!' : PHRASE
        }, fields, cb)
    }

    current(cb, fields={ ID : null, COUNTRY : null, COUNTRY_CODE : null, REGION : null, CITY : null, ZIP : null, LATITUDE : null, LONGITUDE : null, TIMEZONE : null, LANG : null }) {
        GraphQL.query('location_current', {
            
        }, fields, cb)
    }
}

const Location = new LocationClass()

export default Location